import React from 'react';
import { observer } from 'mobx-react-lite';
import { FileUpload } from '@insurancemenu/imenu-components-lib';
import { UPLOAD_FILE_TYPES } from '@insurancemenu/imenu-components-lib/dist/components/FileUpload';
import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { UploadJsonModalDelegate } from 'store/pages/rfq/rfq-template/shelf-rfq-product-templates/uploadJsonModalDelegate';
import { FileUploadStyled } from './styles';
import { SHELF_PRODUCT_TEMPLATES_UPLOAD_JSON_MODAL_TEST_IDS } from '../constants';

interface Props {
  uploadJsonModalDelegate: UploadJsonModalDelegate;
  onUploadJson: () => Promise<void>;
}

const UploadJsonModal: React.FC<Props> = observer(({ uploadJsonModalDelegate, onUploadJson }) => {
  return (
    <ActionModal
      show={uploadJsonModalDelegate.isVisible}
      title="Upload JSON"
      subtitle={
        <>
          Upload one JSON file to quickly create a product template for
          <br /> <b>{uploadJsonModalDelegate.productName}</b>.
        </>
      }
      modalType={ModalType.NO_ICON}
      closeButtonText="Cancel"
      onClose={uploadJsonModalDelegate.close}
      actionButtonText="Upload File"
      onAction={onUploadJson}
      loading={uploadJsonModalDelegate.isModalLoading}
      modalContent={
        <FileUploadStyled data-test-id={SHELF_PRODUCT_TEMPLATES_UPLOAD_JSON_MODAL_TEST_IDS.FILE_UPLOAD}>
          <FileUpload
            fileMimeTypes={[UPLOAD_FILE_TYPES.json]}
            messageForRejectedFiles="Please upload only json file"
            shouldBeReset={uploadJsonModalDelegate.isFileUploadReset}
            onChange={uploadJsonModalDelegate.fileUploadDelegate.setFiles}
          />
        </FileUploadStyled>
      }
      isValid={uploadJsonModalDelegate.fileUploadDelegate.uploadedFileNames.length === 1}
      data-test-id={SHELF_PRODUCT_TEMPLATES_UPLOAD_JSON_MODAL_TEST_IDS.MODAL}
    />
  );
});

export default UploadJsonModal;
